export const crewRates = {
  Formand: {
    function: "Formand",
    functionDisplay: "Formand",
    markers: ["06:00", "16:00", "22:00"],
    price: "",
    sum: "",
    pool: "",
    unfolded: false,
    details: [
      {
        description: "Normal",
        descriptionKey: "Formand normal",
        price: 500,
        hours: 0,
      },
      {
        description: "Overtid",
        descriptionKey: "Formand overtid",
        price: 500,
        hours: 0,
      },
      {
        description: "Nat",
        descriptionKey: "Formand nat",
        price: 500,
        hours: 0,
      },
      {
        description: "Lørdag, Søndag og helligdag",
        descriptionKey: "Formand weekend",
        price: 500,
        hours: 0,
      },
    ],
  },
  Teamleder: {
    function: "Teamleder",
    functionDisplay: "Teamleder",
    markers: ["06:00", "16:00", "22:00"],
    price: "",
    sum: "",
    pool: "",
    unfolded: false,
    details: [
      {
        description: "Normal",
        descriptionKey: "Teamleder normal",
        price: 500,
        hours: 0,
      },
      {
        description: "Overtid",
        descriptionKey: "Teamleder overtid",
        price: 500,
        hours: 0,
      },
      {
        description: "Nat",
        descriptionKey: "Teamleder nat",
        price: 500,
        hours: 0,
      },
      {
        description: "Lørdag, Søndag og helligdag",
        descriptionKey: "Teamleder weekend",
        price: 500,
        hours: 0,
      },
    ],
  },
  Faglært: {
    function: "Faglært",
    functionDisplay: "Faglært",
    markers: ["06:00", "16:00", "22:00"],
    price: "",
    sum: "",
    pool: "",
    unfolded: false,
    details: [
      {
        description: "Normal",
        descriptionKey: "Faglært normal",
        price: 500,
        hours: 0,
      },
      {
        description: "Overtid",
        descriptionKey: "Faglært overtid",
        price: 500,
        hours: 0,
      },
      {
        description: "Nat",
        descriptionKey: "Faglært nat",
        price: 500,
        hours: 0,
      },
      {
        description: "Lørdag, Søndag og helligdag",
        descriptionKey: "Faglært weekend",
        price: 500,
        hours: 0,
      },
    ],
  },
  UFaglært: {
    function: "UFaglært",
    functionDisplay: "UFaglært",
    markers: ["06:00", "16:00", "22:00"],
    price: "",
    sum: "",
    pool: "",
    unfolded: false,
    details: [
      {
        description: "Normal",
        descriptionKey: "UFaglært normal",
        price: 500,
        hours: 0,
      },
      {
        description: "Overtid",
        descriptionKey: "UFaglært overtid",
        price: 500,
        hours: 0,
      },
      {
        description: "Nat",
        descriptionKey: "UFaglært nat",
        price: 500,
        hours: 0,
      },
      {
        description: "Lørdag, Søndag og helligdag",
        descriptionKey: "UFaglært weekend",
        price: 500,
        hours: 0,
      },
    ],
  },
  Maskinfører: {
    function: "Maskinfører",
    functionDisplay: "Maskinfører",
    markers: ["06:00", "16:00", "22:00"],
    price: "",
    sum: "",
    pool: "",
    unfolded: false,
    details: [
      {
        description: "Normal",
        descriptionKey: "Maskinfører normal",
        price: 500,
        hours: 0,
      },
      {
        description: "Overtid",
        descriptionKey: "Maskinfører overtid",
        price: 500,
        hours: 0,
      },
      {
        description: "Nat",
        descriptionKey: "Maskinfører nat",
        price: 500,
        hours: 0,
      },
      {
        description: "Lørdag, Søndag og helligdag",
        descriptionKey: "Maskinfører weekend",
        price: 500,
        hours: 0,
      },
    ],
  },
  Injiceringsoperatør: {
    function: "Injiceringsoperatør",
    functionDisplay: "Injiceringsoperatør",
    markers: ["06:00", "16:00", "22:00"],
    price: "",
    sum: "",
    pool: "",
    unfolded: false,
    details: [
      {
        description: "Normal",
        descriptionKey: "Injiceringsoperatør normal",
        price: 500,
        hours: 0,
      },
      {
        description: "Overtid",
        descriptionKey: "Injiceringsoperatør overtid",
        price: 500,
        hours: 0,
      },
      {
        description: "Nat",
        descriptionKey: "Injiceringsoperatør nat",
        price: 500,
        hours: 0,
      },
      {
        description: "Lørdag, Søndag og helligdag",
        descriptionKey: "Injiceringsoperatør weekend",
        price: 500,
        hours: 0,
      },
    ],
  },
  "Rope-access Supervisor": {
    function: "Rope-access Supervisor",
    functionDisplay: "Rope-access Supervisor",
    markers: ["06:00", "16:00", "22:00"],
    price: "",
    sum: "",
    pool: "",
    unfolded: false,
    details: [
      {
        description: "Normal",
        descriptionKey: "Rope-access Supervisor normal",
        price: 500,
        hours: 0,
      },
      {
        description: "Overtid",
        descriptionKey: "Rope-access Supervisor overtid",
        price: 500,
        hours: 0,
      },
      {
        description: "Nat",
        descriptionKey: "Rope-access Supervisor nat",
        price: 500,
        hours: 0,
      },
      {
        description: "Lørdag, Søndag og helligdag",
        descriptionKey: "Rope-access Supervisor weekend",
        price: 500,
        hours: 0,
      },
    ],
  },
  "Rope-access Worker": {
    function: "Rope-access Worker",
    functionDisplay: "Rope-access Worker",
    markers: ["06:00", "16:00", "22:00"],
    price: "",
    sum: "",
    pool: "",
    unfolded: false,
    details: [
      {
        description: "Normal",
        descriptionKey: "Rope-access Worker normal",
        price: 500,
        hours: 0,
      },
      {
        description: "Overtid",
        descriptionKey: "Rope-access Worker overtid",
        price: 500,
        hours: 0,
      },
      {
        description: "Nat",
        descriptionKey: "Rope-access Worker nat",
        price: 500,
        hours: 0,
      },
      {
        description: "Lørdag, Søndag og helligdag",
        descriptionKey: "Rope-access Worker weekend",
        price: 500,
        hours: 0,
      },
    ],
  },
  SR: {
    function: "SR",
    functionDisplay: "SR",
    markers: ["06:00", "16:00", "22:00"],
    price: "",
    sum: "",
    pool: "",
    unfolded: false,
    details: [
      {
        description: "Normal",
        descriptionKey: "SR normal",
        price: 500,
        hours: 0,
      },
      {
        description: "Overtid",
        descriptionKey: "SR overtid",
        price: 500,
        hours: 0,
      },
      {
        description: "Nat",
        descriptionKey: "SR nat",
        price: 500,
        hours: 0,
      },
      {
        description: "Lørdag, Søndag og helligdag",
        descriptionKey: "SR weekend",
        price: 500,
        hours: 0,
      },
    ],
  },
  Lærling: {
    function: "Lærling",
    functionDisplay: "Lærling",
    markers: ["06:00", "16:00", "22:00"],
    price: "",
    sum: "",
    pool: "",
    unfolded: false,
    details: [
      {
        description: "Normal",
        descriptionKey: "Lærling normal",
        price: 500,
        hours: 0,
      },
      {
        description: "Overtid",
        descriptionKey: "Lærling overtid",
        price: 500,
        hours: 0,
      },
      {
        description: "Nat",
        descriptionKey: "Lærling nat",
        price: 500,
        hours: 0,
      },
      {
        description: "Lørdag, Søndag og helligdag",
        descriptionKey: "Lærling weekend",
        price: 500,
        hours: 0,
      },
    ],
  },
  UnderEntreprenør: {
    function: "UnderEntreprenør",
    functionDisplay: "Under Entreprenør",
    markers: ["06:00", "16:00", "22:00"],
    price: "",
    sum: "",
    pool: "",
    unfolded: false,
    details: [
      {
        description: "Normal",
        descriptionKey: "UnderEntreprenør normal",
        price: 500,
        hours: 0,
      },
      {
        description: "Overtid",
        descriptionKey: "UnderEntreprenør overtid",
        price: 500,
        hours: 0,
      },
      {
        description: "Nat",
        descriptionKey: "UnderEntreprenør nat",
        price: 500,
        hours: 0,
      },
      {
        description: "Lørdag, Søndag og helligdag",
        descriptionKey: "UnderEntreprenør weekend",
        price: 500,
        hours: 0,
      },
    ],
  },
  Ingen: {
    function: "Ingen",
    functionDisplay: "Ingen",
    markers: ["06:00", "16:00", "22:00"],
    price: "",
    sum: "",
    pool: "",
    unfolded: false,
    details: [
      {
        description: "Normal",
        descriptionKey: "Ingen normal",
        price: 500,
        hours: 0,
      },
      {
        description: "Overtid",
        descriptionKey: "Ingen overtid",
        price: 500,
        hours: 0,
      },
      {
        description: "Nat",
        descriptionKey: "Ingen nat",
        price: 500,
        hours: 0,
      },
      {
        description: "Lørdag, Søndag og helligdag",
        descriptionKey: "Ingen weekend",
        price: 500,
        hours: 0,
      },
    ],
  },
};

// A custom pricelist is stored as one JSON blob, so a pricelist saved before a
// function was added to crewRates has no key for it and no way to gain one.
// Fill the missing keys in from the defaults above whenever a saved pricelist is
// loaded, otherwise the function has no editable row on the pricelist screen.
export const withMissingCrewRates = (saved) => {
  const merged = {};
  // Rebuild in crewRates order so a backfilled function lands in the same place
  // it has on a new pricelist, rather than at the bottom of the list.
  Object.keys(crewRates).forEach((key) => {
    merged[key] = saved && saved[key] ? saved[key] : JSON.parse(JSON.stringify(crewRates[key]));
  });
  // Keep anything the saved pricelist has that the defaults no longer do.
  Object.keys(saved || {}).forEach((key) => {
    if (!merged[key]) {
      merged[key] = saved[key];
    }
  });
  return merged;
};



// WEBPACK FOOTER //
// ./src/App/CustomPricelist/constants.js